import SupportPractitionerPlansWorkspacePage from 'src/supportPortal/views/practitioners/therapists/SupportPractitionerPlansWorkspacePage'

export default function SupportPractitionerBundlePacksPage() {
  return <SupportPractitionerPlansWorkspacePage defaultTab="packs" />
}
